import ITitles from '../../shared/interfaces/titles.interface';

export const TITLE_HISTORY: ITitles = {
    icon: 'history',
    title: 'Historial',
    // description: 'Consulta aquí la lista completa de clases dictadas por mes. Selecciona el mes y el año que quieres consultar.',
}